/**
 * Runtime tenant external ID for dashboard API calls (identities list, etc.).
 * Persisted in localStorage; optional build-time default via VITE_TENANT_EXTERNAL_ID.
 */

export const TENANT_EXTERNAL_ID_STORAGE_KEY = "identity_armour_tenant_external_id";

/** Dispatched on same-tab updates after save in Settings. */
export const TENANT_EXTERNAL_ID_CHANGED = "identity-armour:tenant-external-id-changed";

function envTenantFallback(): string {
  return import.meta.env.VITE_TENANT_EXTERNAL_ID?.trim() ?? "";
}

/**
 * Returns the tenant external ID: localStorage override if set, otherwise Vite env default.
 */
export function getTenantExternalId(): string {
  if (typeof localStorage === "undefined") {
    return envTenantFallback();
  }
  const stored = localStorage.getItem(TENANT_EXTERNAL_ID_STORAGE_KEY);
  if (stored !== null) {
    return stored.trim();
  }
  return envTenantFallback();
}

/**
 * Persists the tenant external ID and notifies listeners (e.g. Identities page refresh).
 */
export function setTenantExternalId(value: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(TENANT_EXTERNAL_ID_STORAGE_KEY, value.trim());
  window.dispatchEvent(new CustomEvent(TENANT_EXTERNAL_ID_CHANGED));
}

/** Clears the saved override so the build default (if any) applies again. */
export function clearTenantExternalId(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(TENANT_EXTERNAL_ID_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(TENANT_EXTERNAL_ID_CHANGED));
}
